import '@/plugins/moment-timezone'

import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import App from './App.vue'
import router from '@/router/index.js'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'

Vue.use(VueCookies)

axios.defaults.withCredentials = true

Vue.use(VueAxios, axios)

Vue.config.productionTip = false
new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),
}).$mount('#app')
